const utils = require("Sources/utils/utils");

var dialog = (function()
{
  var Dialog = {};

  var LanguageManager = require("Sources/services/languagemanager");

  Dialog.showMessageDialog = function(title, message, callback, disposable)
  {
    setDialogText(title, message, "modal.buttons.ok", "");

    changeModalClickHandlers(callback);

    show(disposable);
  };

  Dialog.showOkCancelDialog = function(title, message, okCallback, cancelCallback, disposable)
  {
    setDialogText(title, message, "modal.buttons.ok", "modal.buttons.cancel");

    changeModalClickHandlers(okCallback, cancelCallback);

    show(disposable);
  };

  Dialog.showYesNoDialog = function(title, message, yesCallback, noCallback, disposable)
  {
    setDialogText(title, message, "modal.buttons.yes", "modal.buttons.no");

    changeModalClickHandlers(yesCallback, noCallback);

    show(disposable);
  };

  Dialog.showCustomDialog = function(html, top, disposable)
  {
    setDialogContent(html);

    show(disposable, top);
  };

  Dialog.showDialog = function()
  {
    show();
  };

  Dialog.hideDialog = function()
  {
    hide();
  };

  function resetDialog()
  {
    var initialContent = "<div class=\"modal-header\">" +
                            "<h4 id=\"dialog-title\"></h4>" +
                          "</div>" +
                          "<div class=\"modal-body\">" +
                            "<p id=\"dialog-body-content\"></p>" +
                          "</div>" +
                          "<div class=\"modal-footer\">" +
                            "<button id=\"dialog-btn1\" type=\"button\" class=\"btn btn-main no-icon message_dialog_button\"></button>" +
                            "<button id=\"dialog-btn2\" type=\"button\" class=\"btn btn-main no-icon message_dialog_button\"></button>" +
                          "</div>";

    var dialog = $("#modal-dialog");
    dialog.find(".modal-content").empty().html(initialContent);
  }

  function setDialogText(title, message, button1, button2)
  {
    resetDialog();

    var titleEl = $("#dialog-title");
    var textEl = $("#dialog-body-content");
    var btn1El = $("#dialog-btn1");
    var btn2El = $("#dialog-btn2");

    if(utils.isNullOrEmpty(button1))
    {
      btn1El.hide();
    }
    else
    {
      btn1El.show();
    }

    if(utils.isNullOrEmpty(button2))
    {
      btn2El.hide();
    }
    else
    {
      btn2El.show();
    }

    if(!utils.isNullOrEmpty(button1) && utils.isNullOrEmpty(button2))
    {
      btn1El.css("float", "none");
      btn1El.css("width", "100%");
    }
    else if(utils.isNullOrEmpty(button1) && !utils.isNullOrEmpty(button2))
    {
      btn2El.css("float", "none");
      btn2El.css("width", "100%");
    }


    titleEl.html(LanguageManager.getValueForKey(title)).attr("data-localize", title);
    textEl.html(LanguageManager.getValueForKey(message)).attr("data-localize", message);
    btn1El.html(LanguageManager.getValueForKey(button1)).attr("data-localize", button1);
    btn2El.html(LanguageManager.getValueForKey(button2)).attr("data-localize", button2);
  };

  function changeModalClickHandlers(button1Cb, button2Cb)
  {
    $("#dialog-btn1").off();
    $("#dialog-btn2").off();

    $("#dialog-btn1").on("click", function(e)
    {
      Dialog.hideDialog();
      if(button1Cb !== null && typeof button1Cb === "function")
      {
        button1Cb(e);
      }
    });

    $("#dialog-btn2").on("click", function(e)
    {
      Dialog.hideDialog();
      if(button2Cb !== null && typeof button2Cb === "function")
      {
        button2Cb(e);
      }
    });
  };

  function setDialogContent(html)
  {
    var dialogEl = $("#modal-dialog").find(".modal-content").empty();

    if(utils.isString(html))
    {
      dialogEl.html(html);
    }
    else
    {
      dialogEl.append(html);
    }
  };

  function show(disposable, top)
  {
    addBackdrop(disposable);
    $("body").addClass("modal-open");
    var dialog = $("#modal-dialog").focus();
    dialog.show();
    dialog[0].offsetWidth;
    dialog.addClass("in");

    if(top === true)
    {
      dialog.find(".modal-dialog").addClass("top");
    }
  };

  function hide()
  {
    $("#modal-backdrop").remove();
    $("body").removeClass("modal-open");
    var dialog = $("#modal-dialog");
    dialog.removeClass("in");
    setTimeout(function()
    {
      dialog.hide();
      dialog.find(".modal-dialog").removeClass("top");
    }, 200);
  };

  function addBackdrop(disposable)
  {
    if($("#modal-backdrop").length)
      return;

    var backdrop = document.createElement("div");
    backdrop.id = "modal-backdrop";
    backdrop.className = "modal-backdrop fade";

    $("body").append(backdrop);
    $("#modal-backdrop").addClass("in");

    if(typeof disposable === "undefined" || disposable === true)
    {
      $("#modal-dialog").off().on("click", function(e)
      {
        if(e.target.className === ".modal-content" || $(e.target).closest(".modal-content").length)
        {
          e.preventDefault();
          e.stopPropagation();
          return;
        }

        Dialog.hideDialog();
      });
    }
    else
    {
      $("#modal-dialog").off();
    }
  }

  return Dialog;
}());

module.exports = dialog;



// WEBPACK FOOTER //
// ./app/js/utils/modal.js